export const FETCH_DATA_FULFILLED = 'FETCH_DATA_FULFILLED';
export const FETCH_DATA_TIMES = 'FETCH_DATA_TIMES';
export const FETCH_DATA_REJECTED = 'FETCH_DATA_REJECTED';
export const CHOSE_STATION = 'CHOSE_STATION';
export const CHOSE_DATE = 'CHOSE_DATE';
export const NEW_ORDER = 'NEW_ORDER';
export const CREATE_ORDER_REJECT = 'CREATE_ORDER_REJECT';